<div ngModelGroup="comboConsultaBanco-{{data}}" fxFlex="100">
    <combo-pesquisavel #comboConsultaBanco
                       nome="consulta-banco-{{data}}"
                       [itens]="dados"
                       itemDescricao="nome"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome da Consulta do Banco"
                       [label]="label"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
